 (function(h,o,u,n,d) {
        h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
        d=o.createElement(u);d.async=1;d.src=n
        n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
      })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js','DD_RUM')
      window.DD_RUM.onReady(function() {
        window.DD_RUM.init({
          clientToken: 'pub744c3a686fbb430f0c471a3e7c9f7850',
          applicationId: 'd2e82e90-9c7a-4451-bbcb-e9da21acfb47',
          site: 'datadoghq.com',
          service: '&livy',
          env: 'prod',
          // Specify a version number to identify the deployed version of your application in Datadog
          version: '2.0.0',
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'allow',
        });
      });


function initPLPgallery() {
  let swiperWrapper = '.collection__products .image-gallery:not(.swiper-initialized)';
  import(flu.chunks.swiper).then(_ref => {
    let {
      Swiper,
      Pagination
    } = _ref;
    this.mobileSwiper = new Swiper(swiperWrapper, {
      modules: [Pagination],
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        dynamicBullets: true,
        dynamicMainBullets: 4,
        clickable: true
      },
      watchSlidesProgress: true,
      autoHeight: true
    });
  });
}

function addBusinessDays(daysToAdd) {
  let currentDate = new Date();
  let count = 0;

  while (count < daysToAdd) {
    currentDate.setDate(currentDate.getDate() + 1);
    const dayOfWeek = currentDate.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count++;
    }
  }

  return currentDate;
}

document.addEventListener('DOMContentLoaded', (event) => {
  // lead time on PDP
  let leadTime = document.getElementById('lead-time');
  let days = leadTime ? leadTime.getAttribute('data-lead-time') : false;
  if (leadTime && days) {
    shipDate = addBusinessDays(days);
    document.getElementById('ship-by-date').innerHTML = '<strong>' + shipDate.toLocaleDateString('en-US') + '</strong>';
  }

  // PLP mobile gallery swiping
  initPLPgallery();
  const targetNode = document.getElementsByClassName('collection__products--mobile-gallery')[0];
  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          console.log('more products');
          initPLPgallery();
        }
      }
    });
    observer.observe(targetNode, {
      childList: true
    });
  }

  // product sets
  const setOptionWrap = document.getElementsByClassName('set-option-wrapper')[0];
  if (setOptionWrap) {
    // add event listener to change current variant id
    const options = setOptionWrap.getElementsByTagName('select');
    for (let i = 0; i < options.length; i++) {
      options[i].addEventListener('change', function (event) {
        const setOption = event.target.closest('.set-option');
        if (!setOption) return;
        const controlsGroup = setOption.querySelector('.product__variants-wrapper');
        const selectedOptions = [];
        const selects = setOption.querySelectorAll('select[data-index]');
        
        selects.forEach(select => {
          selectedOptions.push(select.value);
        });

        const jsonEl = setOption.querySelector('[data-variant-json]');
        if (!jsonEl) return;
        const variants = JSON.parse(jsonEl.textContent);
        const matchedVariant = variants.find(variant => {
          return selectedOptions.every((value, index) => {
            return variant[`option${index + 1}`] === value;
          });
        });

        if (matchedVariant && controlsGroup) {
          controlsGroup.setAttribute(
            'data-current-variant-id',
            matchedVariant.id
          );

          console.log('Updated variant ID:', matchedVariant.id);
        }
      });
    }

    // update pre-selected products on load based on initial variant id
    setTimeout(()=>{
      document.querySelectorAll('.set-option').forEach(wrapper => {
        const initialVariantId = wrapper.querySelector('.product__variants-wrapper').dataset.initialVariantId;
        console.log(initialVariantId)
        if (!initialVariantId) return;

        const jsonEl = wrapper.querySelector('[data-variant-json]');
        if (!jsonEl) return;

        const variants = JSON.parse(jsonEl.textContent);
        const match = variants.find(v => String(v.id) === String(initialVariantId));
        if (!match) return;

        Object.keys(match).forEach((key, index) => {
          if (!key.startsWith('option')) return;

          const value = match[key];
          if (!value) return;

          const btn = wrapper.querySelector(
            `[data-option-value="${CSS.escape(value)}"]`
          );
          const opt = wrapper.querySelector(
            `.select-wrapper option[value="${CSS.escape(value)}"]`
          );

          if (btn) btn.click();
          if (opt) {
            opt.selected = true;

            const event = new Event('change', { bubbles: true });
            wrapper.querySelector(
              `.select-wrapper select`
            ).dispatchEvent(event);
          }
        });
      });
    }, 1000);

    // finish swatches sync based on selection
    const sets = document.querySelectorAll('.set-option');
    if (sets.length < 2) return;

    const sourceSet = sets[0]; // master controller
    const targetSets = Array.from(sets).slice(1);

    function syncToTargets(value) {
      targetSets.forEach(set => {
        // 1. Try swatch buttons
        const matchBtn = set.querySelector(
          `[data-option-buttons] button[data-option-value="${CSS.escape(value)}"]`
        );

        if (matchBtn) {
          matchBtn.click();
          return;
        }

        // 2. Fallback to select dropdown
        const select = set.querySelector('select');
        if (select) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // --- Swatch clicks ---
    const sourceButtons = sourceSet.querySelectorAll('[data-option-buttons] button');

    sourceButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.getAttribute('data-option-value');
        if (value) syncToTargets(value);
      });
    });

    // --- Select dropdown fallback ---
    const sourceSelect = sourceSet.querySelector('select');

    if (sourceSelect) {
      sourceSelect.addEventListener('change', () => {
        syncToTargets(sourceSelect.value);
      });
    }

    // add set to bag button
    const addAllBtn = document.getElementById('add-all-to-cart');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        addAllBtn.textContent = 'Adding...';
        const setOptions = document.querySelectorAll('.set-option');
        const items = [];

        setOptions.forEach(setOption => {
          const controlsGroup = setOption.querySelector('.product__variants-wrapper');
          if (!controlsGroup) return;
          const variantId = controlsGroup.getAttribute('data-current-variant-id');

          if (variantId) {
            items.push({
              id: parseInt(variantId, 10),
              quantity: 1
            });
          }
        });

        if (!items.length) {
          console.warn('No variants found');
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(res => res.json())
        .then(data => {
          console.log('Added to cart:', data);

          addAllBtn.textContent = 'Added!';

          // redirect to cart
          // window.location.href = '/cart';

          // open cart drawer
          // document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(err => {
          console.error('Error adding to cart:', err);

          // todo: display error to customer
        })
        .finally(()=>{
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            document.querySelector('.pplr_cart_count').innerHTML = cart.item_count;
          });

          setTimeout(() => {
            addAllBtn.textContent = 'Add Set to Bag';
          }, 1500);
        });
      });
    }
  }
});
